<top-nav-bar [navTitle]="navTitle" [showButtons]="true" [isGrayBackground]="true">
  <ng-container top-nav-bar-button>
    <create-okr-dropdown-button *hasPermissions="'ManageGoals'" [showNewDesign]="true"></create-okr-dropdown-button>
  </ng-container>

  <ng-template #navTitle>
    <span>{{ "dashboard_next" | localize }}</span>
    <ui-label *ngIf="showBetaLabel" uiColor="grey">BETA</ui-label>
  </ng-template>
</top-nav-bar>
